export default "__VITE_ASSET__QmDJfzjSQ1Yyan8BZrNlzA__"